import { Box, Stack, Typography } from '@mui/material';

import FinchBird from '../base/FinchBird';

interface WelcomeScreenProps {
  message?: string;
  description?: string;
}

const WelcomeScreen = ({
  message = 'No matters found',
  description = "Make sure you've completed the required onboarding to ensure your user is properly set up with Finch.",
}: WelcomeScreenProps) => {
  return (
    <Stack
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="80vw"
      textAlign="center"
      p={3}
      gap={4}
    >
      <Box mb={3}>
        <FinchBird />
      </Box>
      <Stack gap={4} maxWidth="400px">
        <Typography variant="h1">Welcome to Finch!</Typography>
        <Typography variant="h3">{message}</Typography>
        <Typography variant="body1" paragraph>
          {description}
        </Typography>
        <Typography variant="body1" paragraph>
          Email <a href="mailto:admin@finchlegal.com">admin@finchlegal.com</a>{' '}
          to get this process going. Otherwise, you can call your Finch number,
          dial in your client, and when you hang up the call, refresh this site
          and you should see your generated case information magically appear!
        </Typography>
      </Stack>
    </Stack>
  );
};

export default WelcomeScreen;
